import DeepFocusLogo from "@/assets/icons/deep-focus-logo.svg";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import DeepFocusTimer from "./DeepFocusTimer";
import DiskJockey from "./DiskJockey";

interface DeepFocusHeaderProps {
    onClose: () => void;
}

const DeepFocusHeader = ({ onClose }: DeepFocusHeaderProps) => {
    const { t } = useTranslation();

    return (
        <div className="fixed left-0 right-0 top-3 z-fullscreen flex h-15 items-center justify-between px-11 text-white">
            <div className="text-base font-semibold flex items-center gap-6">
                {" "}
                <img
                    className="h-6 w-auto"
                    src={DeepFocusLogo}
                    alt="Deep Focus"
                />{" "}
                {t("deepFocus.title")}
            </div>
            <div className="flex items-center gap-4">
                <DeepFocusTimer />
                <DiskJockey />
                <Button
                    aria-label={t("common.close")}
                    className="h-10 w-10"
                    onClick={onClose}
                    size="smallCircle"
                    variant="deepFocus"
                >
                    <X />
                </Button>
            </div>
        </div>
    );
};

export default DeepFocusHeader;
